/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, createContext, useState, ReactChild, useContext } from 'react';
// import Cookies from 'js-cookie';
interface UserContext {
  user?: any;
  setUser?: any;
  userTrigger?: any;
  setUserTrigger?: any;
  rePing?: any;
  setRePing?: any;
  rePinging?: any;
  setRePinging?: any;
  logout?: any;
}

const context = createContext<UserContext>({});

const { Provider } = context;

interface Props {
  children: ReactChild | ReactChild[];
}

export const UserProvider: FC<Props> = ({ children }) => {
  const [user, setUser] = useState<any>();
  const [userTrigger, setUserTrigger] = useState<boolean>();
  const [rePing, setRePing] = useState<boolean>(false);
  const [rePinging, setRePinging] = useState<boolean>(false);

  const logout = () => {
    setUser({ isLoggedIn: false });
    localStorage.removeItem('token');
  };

  return (
    <Provider
      value={{
        user,
        setUser,
        userTrigger,
        setUserTrigger,
        rePing,
        setRePing,
        rePinging,
        setRePinging,
        logout
      }}>
      {children}
    </Provider>
  );
};

export const useUser = () => useContext(context);
